export const colors = {
  primary: '#FFC734',
  black: '#000000',
  white: '#FFFFFF',
  greyDark: '#737373',
  grey: '#E6E6E6',
  greyLight: '#F2F1F1',
  background: '#FEFEFE'
}
